export class CampaignApiModel {
    campaignID?: number;
    emailTemplateID?: number;
    title: string;
    startDate: string;
    createDate: string;
}